import axios from 'axios'

function createInstance (csrfToken) {
  return axios.create({
    withCredentials: true,
    baseURL: process.env.VUE_APP_OWNERS_BRIDGE_HOST,
    headers: {
      'X-CSRF-TOKEN': csrfToken,
    },
  })
}

export {
  createInstance,
}
